module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/crocodile-portuguese.c9e6e7e5.jpg";